import React from "react";
import dynamic from "next/dynamic";
import { useInView } from "react-intersection-observer";
import { Details } from "../../data/achievements";

// Dynamically import CountUp component for client-side use only
const CountUp = dynamic(() => import("react-countup"), { ssr: false });

// Format number in Indian style (lakh/crore)
function formatIndianNumber(x) {
  if (x == null) return "";
  const num = x.toString().replace(/,/g, "");
  let lastThree = num.substring(num.length - 3);
  let otherNumbers = num.substring(0, num.length - 3);
  if (otherNumbers !== "") lastThree = "," + lastThree;
  return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
}

export default function DetailsCounter() {
  // Function to extract numeric values from string
  const getNumericValue = (value) => parseInt(value.replace(/[^0-9]/g, ""), 10);

  return (
    <section className="layout-pt-md layout-pb-md bg-beige-1">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {Details.map((elm, i) => {
            // Hook to detect when the element is in view
            const { ref, inView } = useInView({
              triggerOnce: true, // Trigger the animation only once
              threshold: 0.5, // 50% of the element is visible
            });

            const numericValue = getNumericValue(elm.title);

            return (
              <div key={elm.id} ref={ref} className="text-center">
                <div
                  className="counter transition-all duration-500 ease-in-out transform hover:scale-105"
                  data-aos="fade-left"
                  data-aos-duration={(i + 1) * 400}
                >
                  <div className="counter__number text-3xl font-bold text-gray-900" style={{ fontSize: "35px", color: "#140342"}}>
                    {inView ? (
                      <CountUp
                        end={numericValue}
                        duration={2}
                        formattingFn={formatIndianNumber}
                      />
                    ) : (
                      formatIndianNumber(numericValue)
                    )}
                    {elm.title === "3000" && <span>+</span>}
                  </div>
                  <div className="counter__title text-gray-600 mt-2 text-lg" style={{ fontSize: "15px", color: "#4F547B"}}>
                    {elm.text}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
